import { cva, type VariantProps } from "class-variance-authority";

export const dropdownMenuItemVariants = cva(
  "relative flex min-h-10 cursor-pointer items-center gap-2.5 rounded-md px-3 text-sm outline-none select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "text-foreground focus:bg-sidebar-active [&_svg]:text-subtle",
        destructive: "text-bad focus:bg-bad/10",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export type DropdownMenuItemVariantProps = VariantProps<typeof dropdownMenuItemVariants>;
